// Design tokens aligned with OpenCareNorway/Web (theme.css + main.css)

export const accent = {
  main: '#e67e22',
  dark: '#b8540f',
  soft: 'rgba(230, 126, 34, 0.12)'
};

export const lightTokens = {
  bg: '#f6f4ee',
  fg: '#0e2841',
  surface: '#ffffff',
  panel: '#0e2841',
  onPanel: '#ffffff',
  navBg: 'rgba(246, 244, 238, 0.92)',
  ctaBg: '#0e2841',
  ctaBgHover: '#0a1f33',
  ctaFg: '#ffffff',
  border: 'rgba(14, 40, 65, 0.18)',
  cardShadow: 'rgba(14, 40, 65, 0.08)',
  ink70: 'rgba(14, 40, 65, 0.75)',
  pillDriftBg: '#e8f4ec',
  pillDriftFg: '#1a6b3c'
};

export const darkTokens = {
  bg: '#0b141f',
  fg: '#e8edf2',
  surface: '#152232',
  panel: '#060d14',
  onPanel: '#e8edf2',
  navBg: 'rgba(11, 20, 31, 0.92)',
  ctaBg: '#e67e22',
  ctaBgHover: '#b8540f',
  ctaFg: '#ffffff',
  border: 'rgba(232, 237, 242, 0.18)',
  cardShadow: 'rgba(0, 0, 0, 0.28)',
  ink70: 'rgba(232, 237, 242, 0.75)',
  pillDriftBg: '#1a3d2a',
  pillDriftFg: '#7dcea0'
};

export const fontFamily = "'Manrope', -apple-system, BlinkMacSystemFont, system-ui, sans-serif";

export const THEME_STORAGE_KEY = 'oc_theme';
